var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddLink = function SvgAddLink(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3894 9.80535C7.73526 10.2677 8.17652 10.6503 8.68324 10.9272C9.18996 11.204 9.7503 11.3686 10.3262 11.4099C10.9022 11.4511 11.4803 11.368 12.0213 11.1662C12.5623 10.9644 13.0535 10.6486 13.4618 10.2402L15.8778 7.82419C16.6113 7.06473 17.0172 6.04757 17.008 4.99176C16.9988 3.93596 16.5753 2.926 15.8288 2.17941C15.0822 1.43282 14.0722 1.00933 13.0164 1.00015C11.9606 0.990978 10.9434 1.39685 10.184 2.13036L8.79877 3.50751",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6107 8.19477C10.2648 7.7324 9.82358 7.34981 9.31686 7.07297C8.81014 6.79612 8.24981 6.63149 7.67387 6.59024C7.09793 6.549 6.51985 6.6321 5.97885 6.8339C5.43785 7.03571 4.94657 7.35151 4.53835 7.75988L2.1223 10.1759C1.3888 10.9354 0.982921 11.9526 0.992096 13.0084C1.00127 14.0642 1.42476 15.0741 2.17135 15.8207C2.91795 16.5673 3.92791 16.9908 4.98371 17C6.03951 17.0091 7.05668 16.6033 7.81613 15.8698L9.19328 14.4926",
    stroke: "#7D86A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_link.9bb7d9dc.svg";
export { ForwardRef as ReactComponent };